import src from "IMAGE";
export default { src, width: 410, height: 411, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAKUlEQVR42rXOoREAAAjDQPZfmBYDd9WAAvEuIkZGbuw2cIeMAUB5fOgUR4P6r78eYTEAAAAASUVORK5CYII="};
